// extracted by mini-css-extract-plugin
export var subtitle = "_ck-2";
export var title = "_ck-0";
export var titleNoWrap = "_ck-1";